export interface Casting {
  castingSessionId: string;
}

export const CASTING_SESSION_ID_QUERY_STRING = 'castingSessionId';
